/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-nested-ternary */
import React, { useMemo } from 'react'
import { ReactSVG } from 'react-svg'
import { useCallout1Query } from './hooks/use-callout1-query'
import { useCallout2Query } from './hooks/use-callout2-query'
import { useCaseStudiesQuery } from './hooks/use-case-studies-query'
import { useContactQuery } from './hooks/use-contact-query'
import { useCouponSectionQuery } from './hooks/use-coupon-section-query'
import { useFeaturedServiceQuery } from './hooks/use-featured-service-query'
import { useFooterQuery } from './hooks/use-footer-query'
import { useGeneralSchemaQuery } from './hooks/use-general-schema-query'
import { useHeaderQuery } from './hooks/use-header-query'
import { useHeroCommonItemsQuery } from './hooks/use-hero-common-items-query'
import { useHirschbergCaresQuery } from './hooks/use-hirschberg-cares-query'
import { useMultiStepFormQuery } from './hooks/use-multi-step-form-query'
import { usePageSpecificSchemaQuery } from './hooks/use-page-specific-schema-query'
import { usePostHeroDefaultQuery } from './hooks/use-post-hero-default-query'
import { useServiceAreasQuery } from './hooks/use-service-areas-query'
import { useServicesMenuQuery } from './hooks/use-services-menu-query'
import { useTestimonialsQuery } from './hooks/use-testimonials-query'
import { useVideoSectionQuery } from './hooks/use-video-section-query'
import { useWhyHirschbergQuery } from './hooks/use-why-hirschberg-query'
import favicon from './images/favicon.png'

export function GeneralSchemaFunction() {
  const { wp, site, query1, forRatingValuePart1, forRatingValuePart2 } = useGeneralSchemaQuery()

  const data = wp.nexvelSchemaMarkup.nexvelschema

  return {
    services: data.services,
    cities: data.cities,
    businessName: data.businessName,
    siteUrl: site.siteMetadata.siteUrl,
    businessType: data.businessType,
    logo: data.logo.localFile.publicURL,
    image: data.image.localFile.publicURL,
    businessDescription: data.describeYourBusiness,
    phoneNumber: data.phoneNumber,
    address: data.streetAddress,
    city: data.city,
    state: data.state,
    zip: data.zipCode,
    openSunday: data.hoursOfOperation.sunday.areYouOpen,
    sundayClosingTime: `${data.hoursOfOperation.sunday.close.closeHour}:${data.hoursOfOperation.sunday.close.closeMinute} ${data.hoursOfOperation.sunday.close.amorpm}`,
    sundayOpeningTime: `${data.hoursOfOperation.sunday.open.openHour}:${data.hoursOfOperation.sunday.open.openMinute} ${data.hoursOfOperation.sunday.open.amorpm}`,
    openMonday: data.hoursOfOperation.monday.areYouOpen,
    mondayClosingTime: `${data.hoursOfOperation.monday.close.closeHour}:${data.hoursOfOperation.monday.close.closeMinute} ${data.hoursOfOperation.monday.close.amorpm}`,
    mondayOpeningTime: `${data.hoursOfOperation.monday.open.openHour}:${data.hoursOfOperation.monday.open.openMinute} ${data.hoursOfOperation.monday.open.amorpm}`,
    openTuesday: data.hoursOfOperation.tuesday.areYouOpen,
    tuesdayClosingTime: `${data.hoursOfOperation.tuesday.close.closeHour}:${data.hoursOfOperation.tuesday.close.closeMinute} ${data.hoursOfOperation.tuesday.close.amorpm}`,
    tuesdayOpeningTime: `${data.hoursOfOperation.tuesday.open.openHour}:${data.hoursOfOperation.tuesday.open.openMinute} ${data.hoursOfOperation.tuesday.open.amorpm}`,
    openWednesday: data.hoursOfOperation.wednesday.areYouOpen,
    wednesdayClosingTime: `${data.hoursOfOperation.wednesday.close.closeHour}:${data.hoursOfOperation.wednesday.close.closeMinute} ${data.hoursOfOperation.wednesday.close.amorpm}`,
    wednesdayOpeningTime: `${data.hoursOfOperation.wednesday.open.openHour}:${data.hoursOfOperation.wednesday.open.openMinute} ${data.hoursOfOperation.wednesday.open.amorpm}`,
    openThursday: data.hoursOfOperation.thursday.areYouOpen,
    thursdayClosingTime: `${data.hoursOfOperation.thursday.close.closeHour}:${data.hoursOfOperation.thursday.close.closeMinute} ${data.hoursOfOperation.thursday.close.amorpm}`,
    thursdayOpeningTime: `${data.hoursOfOperation.thursday.open.openHour}:${data.hoursOfOperation.thursday.open.openMinute} ${data.hoursOfOperation.thursday.open.amorpm}`,
    openFriday: data.hoursOfOperation.friday.areYouOpen,
    fridayClosingTime: `${data.hoursOfOperation.friday.close.closeHour}:${data.hoursOfOperation.friday.close.closeMinute} ${data.hoursOfOperation.friday.close.amorpm}`,
    fridayOpeningTime: `${data.hoursOfOperation.friday.open.openHour}:${data.hoursOfOperation.friday.open.openMinute} ${data.hoursOfOperation.friday.open.amorpm}`,
    openSaturday: data.hoursOfOperation.saturday.areYouOpen,
    saturdayClosingTime: `${data.hoursOfOperation.saturday.close.closeHour}:${data.hoursOfOperation.saturday.close.closeMinute} ${data.hoursOfOperation.saturday.close.amorpm}`,
    saturdayOpeningTime: `${data.hoursOfOperation.saturday.open.openHour}:${data.hoursOfOperation.saturday.open.openMinute} ${data.hoursOfOperation.saturday.open.amorpm}`,
    reviewsForRatingValuePart1:
      forRatingValuePart1?.nodes.length &&
      forRatingValuePart1.nodes.map((rating, i) => {
        return {
          index: i,
          rating: rating.rating,
        }
      }),
    reviewsForRatingValuePart2:
      forRatingValuePart2?.nodes.length &&
      forRatingValuePart2.nodes.map((rating, i) => {
        return {
          index: i,
          rating: rating.rating,
        }
      }),
    reviewsQuery:
      query1?.nodes.length &&
      query1.nodes.map((review, i) => {
        return {
          index: i,
          id: review.id,
          sourceType: review.sourceType,
          reviewDate: review.reviewDate,
          rating: review.rating,
          reviewerFirstName: review.reviewer.firstName,
          reviewerLastName: review.reviewer.lastName,
          comments: review.comments,
          businessName: review.businessName,
        }
      }),
    offers: data.offersSchema?.map(offer => {
      return {
        offer: offer.offerSchema,
        url: offer.urlSchema,
      }
    }),
    awards: data.awardsSchema?.map(award => {
      return {
        award: award.awardSchema,
      }
    }),
    brands: data.brandsSchema?.map(brand => {
      return {
        brand: brand.brandSchema,
      }
    }),
    certifications: data.certificationsSchema?.map(certification => {
      return {
        certification: certification.certificationSchema,
      }
    }),
    languages: data.languagesSchema?.map(language => {
      return {
        language: language.languageSchema,
      }
    }),
    organizations: data.organizationsSchema?.map(organization => {
      return {
        organization: organization.organizationSchema,
      }
    }),
    socialProfilesDirectoryListings: data.socialMediaProfilesAndDirectoryListingsSchema?.map(
      item => {
        return {
          socialProfileDirectory: item.socialMediaProfileOrDirectoryListingSchema,
        }
      },
    ),
  }
}
export function SeoFunction(data) {
  const seoData = data.wpPage !== undefined ? data.wpPage : data.wpPost
  return {
    page:
      data.wpPost !== undefined
        ? 'blogPost'
        : data.sitePage?.path === '/blog/'
          ? 'blogIndexPage'
          : null,
    favicon,
    title: seoData?.seo.title,
    metaDescription: seoData?.seo.metaDesc,
    ogTitle: seoData?.seo.opengraphTitle,
    ogDescription: seoData?.seo.opengraphDescription,
    ogUrl: seoData?.seo.opengraphUrl,
    ogSiteName: seoData?.seo.opengraphSiteName,
    ogType: seoData?.seo.opengraphType,
    ogImage: seoData?.seo.opengraphImage?.localFile.publicURL,
    canonicalUrl:
      seoData?.seo.canonical !== ''
        ? seoData?.seo.canonical
        : data.site.siteMetadata.siteUrl + seoData.uri,
    twitterTitle: seoData?.seo.twitterTitle,
    twitterDescription: seoData?.seo.twitterDescription,
    twitterImage: seoData?.seo.twitterImage?.localFile.childImageSharp.gatsbyImageData,
  }
}
export function PageSpecificSchemaFunction(data) {
  const pageData = data.wpPage !== undefined ? data.wpPage : data.wpPost
  const pageSpecificSchemaData = usePageSpecificSchemaQuery().wp

  return {
    businessName: pageSpecificSchemaData.nexvelSchemaMarkup.nexvelschema.businessName,
    businessType: pageSpecificSchemaData.nexvelSchemaMarkup.nexvelschema.businessType,
    phoneNumber: pageSpecificSchemaData.nexvelSchemaMarkup.nexvelschema.phoneNumber,
    streetAddress: pageSpecificSchemaData.nexvelSchemaMarkup.nexvelschema.streetAddress,
    city: pageSpecificSchemaData.nexvelSchemaMarkup.nexvelschema.city,
    state: pageSpecificSchemaData.nexvelSchemaMarkup.nexvelschema.state,
    zipCode: pageSpecificSchemaData.nexvelSchemaMarkup.nexvelschema.zipCode,
    logo: pageSpecificSchemaData.nexvelSchemaMarkup.nexvelschema.logo.localFile.publicURL,
    blogPageUrl: pageSpecificSchemaData.nexvelSchemaMarkup.nexvelschema.blogPageUrl,
    aboutPageUrl: pageSpecificSchemaData.nexvelSchemaMarkup.nexvelschema.aboutPageUrl,
    contactPageUrl: pageSpecificSchemaData.nexvelSchemaMarkup.nexvelschema.contactPageUrl,
    siteUrl: data.site.siteMetadata.siteUrl,
    uri: pageData !== undefined ? pageData.uri : '/blog/',
    title: pageData !== undefined ? pageData.title : 'Blog',
    datePublished: pageData?.date,
    dateModified: pageData?.modified,
    image:
      pageData?.seo?.opengraphImage !== null
        ? // eslint-disable-next-line no-unsafe-optional-chaining
          data.site.siteMetadata.siteUrl + pageData?.seo?.opengraphImage.localFile.publicURL
        : '/blank.jpg',
    author: `${pageData?.author?.node.firstName} ${pageData?.author?.node.lastName}`,
    categories:
      pageData?.categories?.nodes.length &&
      pageData?.categories.nodes.map((category, i) => {
        return {
          index: i,
          name: category.name,
        }
      }),
    tags:
      pageData?.tags?.nodes.length &&
      pageData?.tags.nodes.map((tag, i) => {
        return {
          index: i,
          name: tag.name,
        }
      }),
    articleBody: pageData?.content,
    post: data.wpPost !== undefined,
    videos:
      pageData?.nexvelschemapagesposts?.videos?.length &&
      pageData?.nexvelschemapagesposts?.videos.map((video, i) => {
        return {
          index: i,
          title: video.title,
          url: video.url,
          description: video.description,
          thumbnailImage: video.thumbnailImage.localFile.publicURL,
          uploadDate: video.uploadDate,
        }
      }),
    questionsAndAnswers:
      pageData?.nexvelschemapagesposts?.questionsAndAnswers?.length &&
      pageData?.nexvelschemapagesposts?.questionsAndAnswers.map((qanda, i) => {
        return {
          index: i,
          question: qanda.question,
          answer: qanda.answer,
        }
      }),
    maps:
      pageData?.nexvelschemapagesposts?.maps?.length &&
      pageData?.nexvelschemapagesposts?.maps.map((map, i) => {
        return {
          index: i,
          url: map.mapUrl,
        }
      }),
    digitalDocuments:
      pageData?.nexvelschemapagesposts?.digitaldocuments?.length &&
      pageData?.nexvelschemapagesposts?.digitaldocuments.map((document, i) => {
        return {
          index: i,
          title: document.title,
        }
      }),
    images:
      pageData?.nexvelschemapagesposts?.images?.length &&
      pageData?.nexvelschemapagesposts?.images.map((item, i) => {
        return {
          index: i,
          image: item.image.localFile.publicURL,
          date: item.image.date,
          description: item.image.description,
          title: item.image.title,
        }
      }),
    areaServedGeneral: data.wp.nexvelSchemaMarkup?.nexvelschema.cities.map(city => {
      return {
        city: city.city,
      }
    }),
    areaServedPageSpecific: pageData?.nexvelschemapagesposts?.areaServedLandingPageSchema,
    serviceGeneral: data.wp.nexvelSchemaMarkup?.nexvelschema.services.map(service => {
      return {
        serviceName: service.service,
        relevantPage: service.linkToRelevantPageOnYourWebsite,
      }
    }),
    servicePageSpecific: {
      serviceName: pageData?.nexvelschemapagesposts?.serviceSchema.serviceNameSchema,
      relevantPage: pageData?.nexvelschemapagesposts?.serviceSchema.linkToRelevantServicePageSchema,
    },
    keywords: pageData?.nexvelschemapagesposts?.keywordsSchema?.map(item => {
      return {
        keyword: item.keywordSchema,
      }
    }),
    localAwards: pageData?.nexvelschemapagesposts?.localAwardsSchema?.map(item => {
      return {
        localAward: item.localAwardSchema,
      }
    }),
    latitude: pageData?.nexvelschemapagesposts?.latitudeSchema,
    longitude: pageData?.nexvelschemapagesposts?.longitudeSchema,
    relevantExternalPages: pageData?.nexvelschemapagesposts?.relevantExternalPagesSchema?.map(
      item => {
        return {
          relevantExternalPage: item.relevantExternalPageSchema,
        }
      },
    ),
  }
}
export function MultiStepFormFunction() {
  const { wp } = useMultiStepFormQuery()
  const form = wp.acfOptionsMultiStepForm.multiStepForm
  return {
    logo: {
      src: wp.acfOptionsCommonItems.commonItems.logo.localFile.childImageSharp.gatsbyImageData
        .images.fallback.src,
      alt: wp.acfOptionsCommonItems.commonItems.logoAltText,
      width:
        wp.acfOptionsCommonItems.commonItems.logo.localFile.childImageSharp.gatsbyImageData.width,
      height:
        wp.acfOptionsCommonItems.commonItems.logo.localFile.childImageSharp.gatsbyImageData.height,
    },
    stepTitles: form.stepTitles.map(stepTitle => {
      return {
        title: stepTitle.stepTitle,
      }
    }),
    van: {
      src: form.vanImage.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
      alt: form.vanImageAltText,
      width: form.vanImage.localFile.childImageSharp.gatsbyImageData.width,
      height: form.vanImage.localFile.childImageSharp.gatsbyImageData.height,
    },
    residentialOrCommercial: form.residentialOrCommercial.map(option => {
      return {
        option: option.option,
      }
    }),
    issues: form.issues.map(issue => {
      return {
        issue: issue.issue,
        subIssues: issue.subIssues,
      }
    }),
    moreInfo: form.moreInfo,
    photoText: form.photoText,
    maxUploadText: form.maxUploadText,
    ourPhoneNumber: wp.acfOptionsCommonItems.commonItems.phoneNumberForForm,
    confirmationText: form.confirmationText,
    formSubmittedText: form.formSubmittedText,
    formAction: '/.netlify/functions/form-submission',
    bgColor: 'bg-white',
    borderColor: 'border-gray',
    inputBorderColor: '[&>input]:border-gray',
    inputTextColor: '[&>input]:text-gray [&>input]:mt-2',
    placeholderTextColor: '[&>input]:placeholder:text-gray',
    continueButtonDisabled: 'text-gray fill-gray',
    continueButton: 'text-gray fill-gray-darker3',
    continueButtonBorder: 'border-gray',
    continueButtonBorderDisabled: 'border-gray',
    stepsColor: 'text-white',
    stepsBgColor: 'bg-blue',
    stepMarkerColorActive: 'bg-red',
    stepMarkerColor: 'bg-white',
    selectArrow: 'bg-blue',
    selectArrowDisabled: 'bg-gray',
    selectColor: 'text-gray',
    paragraphColor: 'text-gray',
    uploadBgColor: 'bg-white',
    arrowColor: 'bg-white',
    whatConvertsFormId: 106126,
    checkboxText:
      '<p>By submitting this form and signing up for texts, you consent to receive messages from Hirschberg Mechanical at the provided number, including messages sent via auto-dialer. Consent is not a condition of purchase. Msg & data rates may apply. Msg frequency varies. Unsubscribe at any time by replying STOP or clicking the unsubscribe link (where available). For help, reply HELP. Information will not be shared with third parties for marketing or promotional purposes. <a href="/privacy-policy">Privacy Policy</a> & <a href="/terms-and-conditions">Terms & Conditions</a>.</p>',
    checkboxColor: '#fff',
  }
}
export function BlogPostFunction(data) {
  const defaultImg = usePostHeroDefaultQuery()
  return {
    image: {
      src:
        data.wpPost.featuredImage !== null
          ? data.wpPost.featuredImage.node.localFile.childImageSharp.gatsbyImageData.images.fallback
              .src
          : defaultImg.heroImageDefault.localFile.childImageSharp.gatsbyImageData.images.fallback
              .src,
      srcSet:
        data.wpPost.featuredImage !== null
          ? `${data.wpPost.featuredImage.node.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet}`
          : `${defaultImg.heroImageDefault.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet}`,
      width:
        data.wpPost.featuredImage !== null
          ? data.wpPost.featuredImage.node.localFile.childImageSharp.gatsbyImageData.width
          : defaultImg.heroImageDefault.localFile.childImageSharp.gatsbyImageData.width,
      height:
        data.wpPost.featuredImage !== null
          ? data.wpPost.featuredImage.node.localFile.childImageSharp.gatsbyImageData.height
          : defaultImg.heroImageDefault.localFile.childImageSharp.gatsbyImageData.height,
      alt:
        data.wpPost.featuredImage !== null && data.wpPost.postFeaturedImageAltText !== undefined
          ? data.wpPost.postFeaturedImageAltText.altText
          : defaultImg.heroImageDefaultAltText,
    },
    blogTitle: data.wpPost.title,
    content: data.wpPost.content,
    prevButtonTitle: 'BACK TO PREV',
    nextButtonTitle: 'NEXT POST',
    outerBgColor: 'bg-white',
  }
}
export function BlogOverviewFunction(data) {
  const defaultImg = usePostHeroDefaultQuery()
  return {
    blogList: data.allWpPost.nodes.map(post => {
      return {
        image:
          post.featuredImage !== null
            ? post.featuredImage.node.localFile.childImageSharp.gatsbyImageData.images.fallback.src
            : defaultImg.heroImageDefault.localFile.childImageSharp.gatsbyImageData.images.fallback
                .src,
        srcSet:
          post.featuredImage !== null
            ? `${post.featuredImage.node.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet}`
            : `${defaultImg.heroImageDefault.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet}`,
        width:
          post.featuredImage !== null
            ? post.featuredImage.node.localFile.childImageSharp.gatsbyImageData.width
            : defaultImg.heroImageDefault.localFile.childImageSharp.gatsbyImageData.width,
        height:
          post.featuredImage !== null
            ? post.featuredImage.node.localFile.childImageSharp.gatsbyImageData.height
            : defaultImg.heroImageDefault.localFile.childImageSharp.gatsbyImageData.height,
        alt:
          post.featuredImage !== null && post.postFeaturedImageAltText !== undefined
            ? post.postFeaturedImageAltText.altText
            : defaultImg.heroImageDefaultAltText,
        createdAt: post.date,
        title: post.title,
        description: post.excerpt,
        link: `/blog${post.link}`,
      }
    }),
    blogCardStyles: {
      borderColor: 'border-blue',
      dateBgColor: 'bg-blue',
      dateColor: 'text-white',
      titleColor: 'text-red',
    },
    postsPerPage: data.wp.allSettings.readingSettingsPostsPerPage,
    outerBgColor: 'bg-white',
    arrowColor: '#0C1F4A',
    paginationTextColor: 'text-blue-dark',
  }
}

export function HeaderFunction(handleButton) {
  const { wp, mainMenuDropdownImages, mainMenu, topBarMenu } = useHeaderQuery()
  function dropdownImg(a, b) {
    if (b.filter(e => e.associatedDropdown === a).length > 0) {
      const image2 = b.filter(e => e.associatedDropdown === a)

      return image2
    }
    return false
  }

  const menuImages = mainMenuDropdownImages.mainMenuImages.imageContainer.map(image => {
    return {
      src: image.image.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
      srcSet: `${image.image.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet}`,
      width: image.image.localFile.childImageSharp.gatsbyImageData.width,
      height: image.image.localFile.childImageSharp.gatsbyImageData.height,
      alt: image.altText,
      associatedDropdown: image.whichMenuItemIsThisAssociatedWith,
    }
  })

  return {
    logo: {
      src: wp.acfOptionsCommonItems.commonItems.logo.localFile.childImageSharp.gatsbyImageData
        .images.fallback.src,
      srcSet:
        wp.acfOptionsCommonItems.commonItems.logo.localFile.childImageSharp.gatsbyImageData.images
          .fallback.srcSet,
      width:
        wp.acfOptionsCommonItems.commonItems.logo.localFile.childImageSharp.gatsbyImageData.width,
      height:
        wp.acfOptionsCommonItems.commonItems.logo.localFile.childImageSharp.gatsbyImageData.height,
      sizes:
        wp.acfOptionsCommonItems.commonItems.logo.localFile.childImageSharp.gatsbyImageData.sizes,
    },
    logoAltText: wp.acfOptionsCommonItems.commonItems.logoAltText,
    icon1: wp.acfOptionsCommonItems.commonItems.header.residentialLink.icon.localFile.publicURL,
    icon2: wp.acfOptionsCommonItems.commonItems.header.commercialLink.icon.localFile.publicURL,
    link1: wp.acfOptionsCommonItems.commonItems.header.residentialLink.link.url,
    link2: wp.acfOptionsCommonItems.commonItems.header.commercialLink.link.url,
    phoneLink: `tel:${wp.acfOptionsCommonItems.commonItems.phoneNumber}`,
    button1Text: wp.acfOptionsCommonItems.commonItems.header.residentialLink.textMobile,
    button2Text: wp.acfOptionsCommonItems.commonItems.header.commercialLink.textMobile,
    bgColor1: 'bg-blue',
    bgColor2: 'bg-gray',
    textColor: 'text-white',
    menuButtonBgColor: 'bg-red',
    phoneBgColor: 'bg-blue',
    borderColor: 'border-white',
    menuData: mainMenu.nodes.map(topLevel => {
      return {
        label: topLevel.label,
        link: topLevel.path,
        image: dropdownImg(topLevel.label, menuImages)[0]?.src,
        srcSet: dropdownImg(topLevel.label, menuImages)[0]?.srcSet,
        width: dropdownImg(topLevel.label, menuImages)[0]?.width,
        height: dropdownImg(topLevel.label, menuImages)[0]?.height,
        subMenu: topLevel.childItems.nodes.length
          ? topLevel.childItems.nodes.map(secondLevel => {
              return {
                label: secondLevel.label,
                link: secondLevel.path,
                subMenu: secondLevel.childItems.nodes.length
                  ? secondLevel.childItems.nodes.map(thirdLevel => {
                      return {
                        label: thirdLevel.label,
                        link: thirdLevel.path,
                        subMenu: [],
                      }
                    })
                  : [],
              }
            })
          : [],
      }
    }),
    onRequestServiceClick: handleButton,
    phoneNumber: wp.acfOptionsCommonItems.commonItems.phoneNumber,
    mobileMenuBgColor: 'bg-blue',
    mobileMenuSubBgColor: 'bg-blue',
    mobileMenuTextColor: 'text-white',
    headerBgColor: 'bg-white',
    closeTextColor: 'text-gray',
    dividerBorderColor: 'border-gray',
    breadCrumbHomeLabel: 'Home',
    breadCrumbDivider: '/',
    breadCrumbTextColor: 'text-white',
    mobileActive: 'active:bg-blue-light',
    mobileMenuFontWeight: 'font-normal',
    subMenuFontWeight: 'font-normal',
    mobileCallButtonProps: {
      notLink: false,
      outline: true,
      phone: true,
      text: wp.acfOptionsCommonItems.commonItems.phoneNumber,
      fontSize: 'text-[1.125rem]',
      bgColor: 'bg-red',
      hoverBg: 'hover:bg-red-light',
      hoverTextColor: 'hover:text-white',
      fillColor: 'svgWhite',
      textColor: 'text-white',
      borderColor: 'border-red',
      href: `tel:${wp.acfOptionsCommonItems.commonItems.phoneNumber}`,
    },
    mobileRequestButtonProps: {
      notLink: true,
      outline: true,
      phone: false,
      text: wp.acfOptionsCommonItems.commonItems.header.megaMenuButtonText,
      fontSize: 'text-[1.125rem] py-1',
      bgColor: 'bg-white',
      hoverBg: 'hover:bg-gray',
      hoverTextColor: 'hover:text-blue',
      textColor: 'text-blue',
      borderColor: 'border-white',
      onClick: handleButton,
    },
    topMenuData: topBarMenu.nodes.map(topBar => {
      return {
        label: topBar.label,
        link: topBar.path,
      }
    }),
    topbarBgColor: 'bg-red',
    topBarBorderColor: 'border-white',
    link1Text: wp.acfOptionsCommonItems.commonItems.header.residentialLink.text,
    link2Text: wp.acfOptionsCommonItems.commonItems.header.commercialLink.text,
    emergencyText: wp.acfOptionsCommonItems.commonItems.header.emergencyText,
    estimateButton: handleButton,
    estimateIcon:
      'https://wordpress-1096095-4172839.cloudwaysapps.com/wp-content/uploads/2023/12/calculator.svg',
    estimateText: wp.acfOptionsCommonItems.commonItems.header.estimateText,
    middleBorderColor: 'border-gray-light4',
    phoneIcon: wp.acfOptionsCommonItems.commonItems.header.desktopCallIcon.localFile.publicURL,
    callText: wp.acfOptionsCommonItems.commonItems.header.callText,
    textColor2: 'text-blue',
    textColor3: 'text-red',
    phoneIconBgColor: 'bg-blue',
    callBgColor: 'bg-red-lightest',
    borderTopColor: 'border-red',
    navBgColor: 'bg-blue',
    menuTextColor: 'text-white',
    hoverTextColor: 'hover:text-red',
    requestIcon: wp.acfOptionsCommonItems.commonItems.header.requestButton.icon.localFile.publicURL,
    requestText: wp.acfOptionsCommonItems.commonItems.header.requestButton.text,
    arrowIcon: wp.acfOptionsCommonItems.commonItems.header.requestButton.arrow.localFile.publicURL,
    megaMenuBgColor: 'bg-blue/[97%]',
    megaSubMenuBgColor: 'bg-red',
    menuCallButton: {
      notLink: false,
      outline: true,
      phone: true,
      text: wp.acfOptionsCommonItems.commonItems.phoneNumber,
      fontSize: 'text-[1.125rem] xl:py-2 xxxl:py-[0.6rem]',
      bgColor: 'bg-red',
      hoverBg: 'hover:bg-red-light',
      hoverTextColor: 'hover:text-white',
      fillColor: 'svgWhite xxl:pt-1',
      textColor: 'text-white',
      borderColor: 'border-red',
      href: `tel:${wp.acfOptionsCommonItems.commonItems.phoneNumber}`,
    },
    menuRequestButton: {
      notLink: true,
      outline: true,
      phone: false,
      text: wp.acfOptionsCommonItems.commonItems.header.megaMenuButtonText,
      fontSize: 'text-[1.125rem] xl:-my-[0.125rem] xxl:my-0 xxxl:py-[0.1rem]',
      bgColor: 'bg-white',
      hoverBg: 'hover:bg-gray',
      hoverTextColor: 'hover:text-blue',
      textColor: 'text-blue',
      borderColor: 'border-white',
      onClick: handleButton,
    },
    megaMenuTextColor: 'text-white',
    menuBorderColor: 'border-[#35414A]',
  }
}

export function InteriorContent1(data) {
  return {
    contentSection: data.wpPage.contentSection1.contentSection1,
  }
}
export function InteriorContent2(data) {
  return {
    contentSection: data.wpPage.contentSection2.contentSection2,
  }
}

export function Callout1Function(handleButton) {
  const data = useCallout1Query()
  return {
    truck: {
      src: data.vanImage.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
      srcSet: data.vanImage.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet,
      alt: data.vanImageAltText,
      width: data.vanImage.localFile.childImageSharp.gatsbyImageData.width,
      height: data.vanImage.localFile.childImageSharp.gatsbyImageData.height,
    },
    bgImg: data.backgroundImage.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
    title: data.title,
    textColor: 'text-white',
    button: {
      notLink: true,
      outline: true,
      phone: false,
      onClick: handleButton,
      text: data.buttonText,
      fontSize: 'text-[0.75rem] sm:text-[1.152rem] lg:text-[0.75rem] xxl:text-[1rem]',
      bgColor: 'bg-blue',
      hoverBg: 'hover:bg-red active:bg-red',
      hoverTextColor: 'hover:text-white',
      textColor: 'text-white',
      borderColor: 'border-white !translate-x-1 !translate-y-1 xl:!translate-x-2 xl:!translate-y-2',
    },
    overlayColor1: 'bg-blue',
    overlayColor2: 'bg-red',
    overlayImage: {
      src: data.cutoutImage.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
      srcSet: data.cutoutImage.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet,
      width: data.cutoutImage.localFile.childImageSharp.gatsbyImageData.width,
      height: data.cutoutImage.localFile.childImageSharp.gatsbyImageData.height,
      sizes: data.cutoutImage.localFile.childImageSharp.gatsbyImageData.sizes,
    },
    overlayImageAltText: data.cutoutImageAltText,
  }
}

export function FaqFunction(data) {
  return {
    heading: 'Frequently Asked Questions',
    questions: data.wpPage.nexvelschemapagesposts.questionsAndAnswers?.map(faq => {
      return {
        title: faq.question,
        content: faq.answer,
      }
    }),
    titleColor: 'text-blue',
    tabBgColor: 'bg-transparent',
    tabBorderColor: 'border-[#D9D9D9]',
    borderBottomColor: 'border-b-[#D9D9D9]',
    contentColor: 'text-blue',
    iconColor: 'text-blue',
  }
}

export function ContactFunction() {
  const data = useContactQuery()
  return {
    title: data.title,
    subtitle: data.text,
    bgImg:
      data.desktopBackgroundImage.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
    bgImgMobile:
      data.mobileBackgroundImage.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
    textColor: 'text-white',
    subtitleColor: 'text-white',
    bgColor: 'bg-gradient-to-b from-blue/90 via-blue/90 to-blue-dark',
    form: {
      textColor: '[&>input]:placeholder:text-gray-dark placeholder:text-gray-dark text-gray-dark',
      borderColor: '[&>input]:border-white',
      inputBgColor: 'bg-white',
      actionUrl: '/thank-you/',
      options: data.formOptions.map(option => {
        return {
          label: option.label,
          value: option.value,
        }
      }),
      checkboxText:
        '<p>By submitting this form and signing up for texts, you consent to receive messages from Hirschberg Mechanical at the provided number, including messages sent via auto-dialer. Consent is not a condition of purchase. Msg & data rates may apply. Msg frequency varies. Unsubscribe at any time by replying STOP or clicking the unsubscribe link (where available). For help, reply HELP. Information will not be shared with third parties for marketing or promotional purposes. <a href="/privacy-policy">Privacy Policy</a> & <a href="/terms-and-conditions">Terms & Conditions</a>.</p>',
      checkboxColor: '#fff',
      submitButton: {
        notLink: true,
        outline: true,
        phone: false,
        text: data.submitButtonText,
        fontSize:
          'text-[1.125rem] lg:text-[0.53331rem] xl:text-[0.75rem] xxl:text-[1rem] xxxl:text-[1.33331rem]',
        bgColor: 'bg-red',
        hoverBg: 'hover:bg-blue',
        hoverTextColor: 'hover:text-white',
        textColor: 'text-white',
        borderColor: 'border-red',
      },
    },
    overlayMobile: {
      src: data.mobileCutout.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
      srcSet: data.mobileCutout.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet,
      width: data.mobileCutout.localFile.childImageSharp.gatsbyImageData.width,
      height: data.mobileCutout.localFile.childImageSharp.gatsbyImageData.height,
      sizes: data.mobileCutout.localFile.childImageSharp.gatsbyImageData.sizes,
    },
    overlayAltText: '',
    vanMobile: {
      src: data.mobileVan.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
      srcSet: data.mobileVan.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet,
      width: data.mobileVan.localFile.childImageSharp.gatsbyImageData.width,
      height: data.mobileVan.localFile.childImageSharp.gatsbyImageData.height,
      sizes: data.mobileVan.localFile.childImageSharp.gatsbyImageData.sizes,
    },
    vanAltText: '',
    overlayDesktop: {
      src: data.desktopCutout.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
      srcSet: data.desktopCutout.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet,
      width: data.desktopCutout.localFile.childImageSharp.gatsbyImageData.width,
      height: data.desktopCutout.localFile.childImageSharp.gatsbyImageData.height,
      sizes: data.desktopCutout.localFile.childImageSharp.gatsbyImageData.sizes,
    },
    vanDesktop: {
      src: data.desktopVan.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
      srcSet: data.desktopVan.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet,
      width: data.desktopVan.localFile.childImageSharp.gatsbyImageData.width,
      height: data.desktopVan.localFile.childImageSharp.gatsbyImageData.height,
      sizes: data.desktopVan.localFile.childImageSharp.gatsbyImageData.sizes,
    },
  }
}

export function HirschbergCaresFunction() {
  const data = useHirschbergCaresQuery()
  return {
    bgColor: 'bg-tan',
    title: data.title,
    content: data.text,
    tabs: data.tabs.map(tab => {
      return {
        label: tab.label,
        content: tab.text,
        image: tab.image.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
        link: tab.link.url,
        buttonText: tab.link.title,
      }
    }),
    learnMoreButtonProps: {
      notLink: false,
      outline: true,
      phone: false,
      fontSize:
        'text-base md:text-[1.536rem] lg:text-[0.53331rem] xl:text-[0.75rem] xxl:text-base xxxl:text-[1.33331rem] py-1 md:py-2 lg:py-0',
      bgColor: 'bg-blue',
      hoverBg: 'hover:bg-blue-dark',
      hoverTextColor: 'hover:text-white',
      textColor: 'text-white',
      borderColor: 'border-blue !translate-x-1 !translate-y-1 xl:!translate-x-2 xl:!translate-y-2',
    },
    textColor: 'text-blue',
    textColor2: 'text-gray-dark',
    borderColor: 'border-gray-light3',
    hoverBgColor: 'hover:bg-blue',
    hoverTextColor: 'hover:text-white',
    activeBgColor: '!bg-blue',
    activeTextColor: '!text-white',
    beforeBorderColor: 'before:border-red',
    cardBgColor: 'bg-white',
    svgFillActive: 'fill-white',
  }
}
export function HeroFunction(data, handleButton) {
  const { wp, forRatingValuePart1, forRatingValuePart2 } = useHeroCommonItemsQuery()

  const commonItems = wp.acfOptionsCommonItems.commonItems.heroCommonItems

  function length(obj) {
    return Object.keys(obj).length
  }
  const averageRating = useMemo(() => {
    const reviewsRatings = {
      reviewsForRatingValuePart1:
        forRatingValuePart1?.nodes.length &&
        forRatingValuePart1.nodes.map((rating, i) => {
          return {
            index: i,
            rating: rating.rating,
          }
        }),
      reviewsForRatingValuePart2:
        forRatingValuePart2?.nodes.length &&
        forRatingValuePart2.nodes.map((rating, i) => {
          return {
            index: i,
            rating: rating.rating,
          }
        }),
    }
    const fiveFourThreeRatings = length(reviewsRatings.reviewsForRatingValuePart2)

    const totalRatings = length(reviewsRatings.reviewsForRatingValuePart1)

    const ratingsTotal = reviewsRatings.reviewsForRatingValuePart1
    const total = ratingsTotal.reduce((sum, item) => sum + item.rating, 0)

    let avgRating = total / fiveFourThreeRatings
    avgRating = avgRating.toFixed(1)

    return [avgRating, totalRatings]
  }, [forRatingValuePart1, forRatingValuePart2])

  return {
    fontColor: 'text-white',
    wrench: {
      src: commonItems.wrenchImage.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
      srcSet:
        commonItems.wrenchImage.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet,
      sizes:
        commonItems.wrenchImage.localFile.childImageSharp.gatsbyImageData.images.fallback.sizes,
      width: commonItems.wrenchImage.localFile.childImageSharp.gatsbyImageData.width,
      height: commonItems.wrenchImage.localFile.childImageSharp.gatsbyImageData.height,
      alt: commonItems.wrenchImageAltText,
    },
    button: {
      notLink: true,
      rounded: false,
      iconType: commonItems.buttons[0].iconType,
      iconBgColor: 'bg-white',
      borderColor: 'border-red',
      iconFill: 'svgRed',
      text: commonItems.buttons[0].buttonText,
      bgColor: 'bg-red min-w-[17rem] lg:min-w-0 xl:w-[15rem] xl2:w-[17rem] xxl:w-[19.125rem]',
      hoverBgColor: 'hover:bg-white hover:text-blue',
      fontSize: 'text-base lg:text-sm xl:text-base',
      textColor: 'text-white',
      onClick: handleButton,
    },
    link1: {
      notLink: false,
      rounded: false,
      iconType: commonItems.buttons[1].iconType,
      iconBgColor: 'bg-white',
      borderColor: 'border-orange-light',
      iconFill: 'svgOrange',
      text: commonItems.buttons[1].link.title,
      bgColor:
        'bg-orange-light min-w-[17rem] lg:min-w-0 xl:w-[15rem] xl2:w-[17rem] xxl:w-[19.125rem]',
      hoverBgColor: 'hover:bg-gray hover:text-white',
      fontSize: 'text-base lg:text-sm xl:text-base',
      textColor: 'text-blue',
      href: commonItems.buttons[1].link.url,
      target: commonItems.buttons[1].link.target,
    },
    link2: {
      notLink: false,
      rounded: false,
      iconType: commonItems.buttons[2].iconType,
      iconBgColor: 'bg-white',
      borderColor: 'border-[#518EF7]',
      iconFill: 'svgLightBlue',
      text: commonItems.buttons[2].link.title,
      bgColor: 'bg-[#518EF7] min-w-[17rem] lg:min-w-0 xl:w-[15rem] xl2:w-[17rem] xxl:w-[19.125rem]',
      hoverBgColor: 'hover:bg-red',
      fontSize: 'text-base lg:text-sm xl:text-base',
      textColor: 'text-white',
      href: commonItems.buttons[2].link.url,
      target: commonItems.buttons[2].link.target,
    },
    reviewBadge: {
      rating: averageRating[0],
      bgColor: 'bg-red',
      innerBorderColor: 'before:border-white',
      instance: 1,
      emptyStarColor: 'fill-gray',
      starColor: 'fill-yellow',
    },
    reviewCnt: averageRating[1],
    reviewText: commonItems.reviewText,
    googleIcon: {
      src: commonItems.googleIcon.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
      srcSet:
        commonItems.googleIcon.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet,
      sizes: commonItems.googleIcon.localFile.childImageSharp.gatsbyImageData.images.fallback.sizes,
      width: commonItems.googleIcon.localFile.childImageSharp.gatsbyImageData.width,
      height: commonItems.googleIcon.localFile.childImageSharp.gatsbyImageData.height,
      alt: 'Google Icon',
    },
    isSubPage: !!(data.wpPage.title !== 'Home' && data.wpPage.title !== 'Commercial'),
    bgImg:
      data.wpPage.hero.hero.backgroundImage !== null
        ? data.wpPage.hero.hero.backgroundImage.localFile.childImageSharp.gatsbyImageData.images
            .fallback.src
        : commonItems.defaultBackgroundImage.localFile.childImageSharp.gatsbyImageData.images
            .fallback.src,
    bgImgDesktop:
      data.wpPage.title === 'Home'
        ? data.wpPage.hero.hero.homePageDesktopBackgroundImage.localFile.childImageSharp
            .gatsbyImageData.images.fallback.src
        : data.wpPage.title === 'Commercial'
          ? data.wpPage.hero.hero.commercialPageDesktopBackgroundImage.localFile.childImageSharp
              .gatsbyImageData.images.fallback.src
          : data.wpPage.hero.hero.backgroundImage !== null
            ? data.wpPage.hero.hero.backgroundImage.localFile.childImageSharp.gatsbyImageData.images
                .fallback.src
            : commonItems.defaultBackgroundImage.localFile.childImageSharp.gatsbyImageData.images
                .fallback.src,
    title1: data.wpPage.hero.hero.title1,
    title2: data.wpPage.hero.hero.title2,
    subtitle: data.wpPage.hero.hero.subtitle ? data.wpPage.hero.hero.subtitle : null,
    subtitleColor: data.wpPage.title === 'Home' ? 'text-yellow' : null,
    heroButton:
      data.wpPage.title !== 'Commercial'
        ? null
        : {
            notLink: true,
            outline: true,
            phone: false,
            onClick: handleButton,
            text: commonItems.heroButtonText,
            fontSize: 'text-base',
            bgColor: 'bg-white',
            hoverBg: 'hover:bg-blue',
            hoverTextColor: 'hover:text-white',
            textColor: 'text-black',
            borderColor: 'border-white',
          },
  }
}
export function ServicesMenuFunction() {
  const data = useServicesMenuQuery()
  return {
    menuItems: data.nodes.map(topLevel => {
      return {
        icon: <ReactSVG src={topLevel.menuIcons.icon?.localFile.publicURL} />,
        label: topLevel.label,
        path: topLevel.path,
        childItems:
          topLevel.childItems !== null
            ? {
                nodes: topLevel.childItems.nodes.map(secondLevel => {
                  return {
                    icon: <ReactSVG src={secondLevel.menuIcons.icon?.localFile.publicURL} />,
                    label: secondLevel.label,
                    path: secondLevel.path,
                    childItems:
                      secondLevel.childItems !== null
                        ? {
                            nodes: secondLevel.childItems.nodes.map(thirdLevel => {
                              return {
                                label: thirdLevel.label,
                                path: thirdLevel.path,
                              }
                            }),
                          }
                        : null,
                  }
                }),
              }
            : null,
      }
    }),
    menuItemColor: 'text-white',
    menuItemColorActiveSection: 'text-white',
    menuItemColorActiveSectionBackground: 'bg-red-darker2',
    menuItemColorActive: 'text-white',
    borderColor: 'border-white',
    bgColorTopLevel: 'bg-red-darker2',
    bgColorSecondLevel: 'bg-blue-dark3',
    hoverStates:
      'hover:bg-blue-dark3 active:bg-blue-dark3 hover:text-white active:text-white [&_a]:hover:text-white',
    traditionalListItems: true,
    listDot: `bg-white`,
    thirdLevelLinkColor: `text-white`,
  }
}
export function TestimonialsFunction() {
  const { wpPage, forRatingValuePart1, forRatingValuePart2, reviews } = useTestimonialsQuery()

  function length(obj) {
    return Object.keys(obj).length
  }
  const averageRating = useMemo(() => {
    const reviewsRatings = {
      reviewsForRatingValuePart1:
        forRatingValuePart1?.nodes.length &&
        forRatingValuePart1.nodes.map((rating, i) => {
          return {
            index: i,
            rating: rating.rating,
          }
        }),
      reviewsForRatingValuePart2:
        forRatingValuePart2?.nodes.length &&
        forRatingValuePart2.nodes.map((rating, i) => {
          return {
            index: i,
            rating: rating.rating,
          }
        }),
    }
    const fiveFourThreeRatings = length(reviewsRatings.reviewsForRatingValuePart2)

    const totalRatings = length(reviewsRatings.reviewsForRatingValuePart1)

    const ratingsTotal = reviewsRatings.reviewsForRatingValuePart1
    const total = ratingsTotal.reduce((sum, item) => sum + item.rating, 0)

    let avgRating = total / fiveFourThreeRatings
    avgRating = avgRating.toFixed(1)

    return [avgRating, totalRatings]
  }, [forRatingValuePart1, forRatingValuePart2])

  const { testimonials } = wpPage.testimonials

  return {
    bgImgMobile:
      testimonials.backgroundImageMobile.localFile.childImageSharp.gatsbyImageData.images.fallback
        .src,
    bgImgDesktop:
      testimonials.backgroundImageDesktop.localFile.childImageSharp.gatsbyImageData.images.fallback
        .src,
    title1: testimonials.title,
    titleColor: 'text-blue',
    playButton: testimonials.playButton.localFile.publicURL,
    testimonialTextColor: 'text-white',
    videoTestimonials: testimonials.testimonials.map(testimonial => {
      return {
        image: {
          src: testimonial.image.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
          srcSet:
            testimonial.image.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet,
          sizes: testimonial.image.localFile.childImageSharp.gatsbyImageData.images.fallback.sizes,
          width: testimonial.image.localFile.childImageSharp.gatsbyImageData.width,
          height: testimonial.image.localFile.childImageSharp.gatsbyImageData.height,
          alt: testimonial.altText,
        },
        videoUrl: testimonial.videoUrl.url,
        testimonialText: testimonial.testimonialText,
      }
    }),
    title2: testimonials.title2,
    rating: averageRating[0],
    ratingColor: 'text-white',
    reviewWidgetTextColor: 'text-black-light2',
    reviewCnt: averageRating[1],
    reviewWidgetText: testimonials.reviewWidgetText,
    starPrimary: '#F9BB18',
    starSecondary: '#dddddd',
    reviewTextColor: 'text-gray-dark',
    reviewNameColor: 'text-red',
    borderColor: 'border-gray-light2',
    google: {
      logo: testimonials.reviewIcons.googleIcon.localFile.childImageSharp.gatsbyImageData.images
        .fallback.src,
      srcSet:
        testimonials.reviewIcons.googleIcon.localFile.childImageSharp.gatsbyImageData.images
          .fallback.srcSet,
      width: testimonials.reviewIcons.googleIcon.localFile.childImageSharp.gatsbyImageData.width,
      height: testimonials.reviewIcons.googleIcon.localFile.childImageSharp.gatsbyImageData.height,
    },
    facebook: {
      logo: testimonials.reviewIcons.facebookIcon.localFile.childImageSharp.gatsbyImageData.images
        .fallback.src,
      srcSet:
        testimonials.reviewIcons.facebookIcon.localFile.childImageSharp.gatsbyImageData.images
          .fallback.srcSet,
      width: testimonials.reviewIcons.facebookIcon.localFile.childImageSharp.gatsbyImageData.width,
      height:
        testimonials.reviewIcons.facebookIcon.localFile.childImageSharp.gatsbyImageData.height,
    },
    localReviews: {
      logo: testimonials.reviewIcons.localreviewsIcon.localFile.childImageSharp.gatsbyImageData
        .images.fallback.src,
      srcSet:
        testimonials.reviewIcons.localreviewsIcon.localFile.childImageSharp.gatsbyImageData.images
          .fallback.srcSet,
      width:
        testimonials.reviewIcons.localreviewsIcon.localFile.childImageSharp.gatsbyImageData.width,
      height:
        testimonials.reviewIcons.localreviewsIcon.localFile.childImageSharp.gatsbyImageData.height,
    },
    reviews: reviews.nodes.map(review => {
      return {
        rate: review.rating,
        firstName: review.reviewer.firstName,
        lastName: review.reviewer.lastName,
        logoImage: review.sourceType,
        content: review.comments,
      }
    }),
    link: {
      notLink: false,
      outline: true,
      phone: false,
      text: testimonials.link.title,
      fontSize: 'text-[1.125rem]',
      bgColor: 'bg-red',
      hoverBg: 'hover:bg-blue',
      hoverTextColor: 'hover:text-white',
      textColor: 'text-white',
      borderColor: 'border-red',
      href: testimonials.link.url,
    },
  }
}
export function FooterFunction() {
  const { wp, footerMenu1, footerMenu2 } = useFooterQuery()
  const { footer } = wp.acfOptionsCommonItems.commonItems
  return {
    bgColor: 'bg-blue-dark4',
    footerLogo: {
      src: footer.footerLogo.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
      srcSet: footer.footerLogo.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet,
      sizes: footer.footerLogo.localFile.childImageSharp.gatsbyImageData.images.fallback.sizes,
      width: footer.footerLogo.localFile.childImageSharp.gatsbyImageData.width,
      height: footer.footerLogo.localFile.childImageSharp.gatsbyImageData.height,
      alt: footer.footerLogoAltText,
    },
    titleColor: 'text-white',
    textColor: 'text-gray-light',
    text: footer.text,
    footerMenu1Label: footerMenu1.menuItems.nodes[0].menu.node.name,
    footerMenu1: footerMenu1.menuItems.nodes.map(menu => {
      return {
        label: menu.label,
        path: menu.path,
      }
    }),
    footerMenu2Label: footerMenu2.menuItems.nodes[0].menu.node.name,
    footerMenu2: footerMenu2.menuItems.nodes.map(menu => {
      return {
        label: menu.label,
        path: menu.path,
        target: menu.target,
      }
    }),
    contactLabel: footer.locations.sectionLabel,
    addressLabel: footer.locations.addressLabel,
    address: footer.locations.address,
    callLabel: footer.locations.callLabel,
    phoneNumber: wp.acfOptionsCommonItems.commonItems.phoneNumber,
    hoursLabel: footer.hours.sectionLabel,
    hours: footer.hours.hours,
    grayLine: 'bg-blue-lightest',
    socialMedia: footer.socialMedia.map(social => {
      return {
        icon: social.socialMediaIcon.localFile.publicURL,
        url: social.socialMediaLink.url,
      }
    }),
    copyright: footer.copyright,
    nexvel: {
      logo: {
        src: footer.nexvelLogo.localFile.publicURL,

        width: 177,
        height: 61,
        alt: footer.nexvelLogoAltText,
      },
      link: footer.nexvelLink.url,
    },
  }
}

export function OurCouponsFunction() {
  const data = useCouponSectionQuery()
  return {
    bgImgDesktop:
      data.backgroundImageDesktop.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
    bgImgMobile:
      data.backgroundImageMobile.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
    bgColor: 'bg-blue-light',
    title: data.title1,
    subtitle: data.subtitle1,
    contentTitle: data.title2,
    content: data.subtitle2,
    buttonProps: {
      notLink: false,
      outline: true,
      phone: false,
      text: data.link.title,
      fontSize: 'text-[1.125rem] xxl:text-base xxxl:text-[1.33331rem]',
      bgColor: 'bg-red lg:bg-white py-2 xl:py-0',
      hoverBg: 'hover:bg-blue hover:lg:bg-red',
      hoverTextColor: 'hover:text-white',
      textColor: 'text-white lg:text-blue',
      borderColor: 'border-red lg:border-white',
      href: data.link.url,
    },
    coupons: data.coupons.map(coupon => {
      return {
        title: coupon.text,
      }
    }),
    couponProps: {
      logo: {
        src: data.couponLogo.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
        srcSet: data.couponLogo.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet,
        width: data.couponLogo.localFile.childImageSharp.gatsbyImageData.width,
        height: data.couponLogo.localFile.childImageSharp.gatsbyImageData.height,
        sizes: data.couponLogo.localFile.childImageSharp.gatsbyImageData.sizes,
      },
      logoAltText: data.couponLogoAltText,
      topBgColor: 'bg-white',
      bgColor2: 'bg-red',
      bgColor1: 'bg-blue',
      innerBgColor2: 'bg-red-darker',
      innerBgColor1: 'bg-blue-light2',
      borderColor: 'border-white',
      textColor: 'text-white',
      description: data.couponDescriptionText,
      printText: data.printButtonText,
    },
    textColor: 'text-white',
  }
}
export function VideoSectionFunction() {
  const data = useVideoSectionQuery()
  return {
    title: data.title,
    backgroundImageMobile:
      data.mobileImage.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
    backgroundImageDesktop:
      data.desktopImage.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
    playButton: data.playButton.localFile.publicURL,
    videoUrl: data.videoUrl.url,
    title2: data.title2,
    text: data.text,
    link: data.link.url,
    borderColor: 'border-blue',
    titleColor: 'text-blue',
    textColor: 'text-white',
  }
}
export function Callout2Function(handleButton) {
  const { wpPage, wp } = useCallout2Query()
  const data = wpPage.callout2.callout2
  return {
    backgroundImageMobile:
      data.backgroundImageMobile.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
    backgroundImageDesktop:
      data.backgroundImageDesktop.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
    vanImage: {
      src: data.vanImage.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
      srcSet: data.vanImage.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet,
      sizes: data.vanImage.localFile.childImageSharp.gatsbyImageData.images.fallback.sizes,
      width: data.vanImage.localFile.childImageSharp.gatsbyImageData.width,
      height: data.vanImage.localFile.childImageSharp.gatsbyImageData.height,
      alt: data.vanImageAltText,
    },
    foregroundImage: {
      src: data.foregroundImage.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
      srcSet: data.foregroundImage.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet,
      sizes: data.foregroundImage.localFile.childImageSharp.gatsbyImageData.images.fallback.sizes,
      width: data.foregroundImage.localFile.childImageSharp.gatsbyImageData.width,
      height: data.foregroundImage.localFile.childImageSharp.gatsbyImageData.height,
      alt: data.foregroundImageAltText,
    },
    foregroundImageDesktop: {
      src: data.foregroundImageDesktop.localFile.childImageSharp.gatsbyImageData.images.fallback
        .src,
      srcSet:
        data.foregroundImageDesktop.localFile.childImageSharp.gatsbyImageData.images.fallback
          .srcSet,
      sizes:
        data.foregroundImageDesktop.localFile.childImageSharp.gatsbyImageData.images.fallback.sizes,
      width: data.foregroundImageDesktop.localFile.childImageSharp.gatsbyImageData.width,
      height: data.foregroundImageDesktop.localFile.childImageSharp.gatsbyImageData.height,
      alt: data.foregroundImageAltText,
    },
    title: data.title,
    titleColor: 'text-white',
    phone: {
      notLink: false,
      outline: false,
      phone: true,
      text: wp.acfOptionsCommonItems.commonItems.phoneNumber,
      fontSize: 'text-[1.125rem] xxl:text-[1.91669rem]',
      bgColor: 'bg-white',
      hoverBg: 'hover:bg-gray',
      hoverTextColor: 'hover:text-black-light2',
      fillColor: 'svgRed',
      textColor: 'text-black-light2',
      href: `tel:${wp.acfOptionsCommonItems.commonItems.phoneNumber}`,
    },
    button: {
      notLink: true,
      outline: false,
      phone: false,
      text: data.buttonText,
      fontSize: 'text-[1.125rem] xxl:text-[1.91669rem]',
      bgColor: 'transparent',
      borderColor: 'border-white',
      hoverBg: 'hover:bg-gray',
      hoverTextColor: 'hover:text-black-light2',
      fillColor: 'svgBlue',
      textColor: 'text-white',
      onClick: handleButton,
    },
  }
}
export function FeaturedServicesFunction(handleButton) {
  const { wpPage, wp } = useFeaturedServiceQuery()
  const data = wpPage.featuredServices.featuredServices
  return {
    bgImgMobile:
      data.backgroundImageMobile.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
    bgImgDesktop:
      data.backgroundImageDesktop.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
    title: data.title,
    title2: data.subtitle,
    content: data.text,
    tabs: data.accordions.map(tab => {
      return {
        icon: tab.icon.localFile.publicURL,
        label: tab.label,
        title: tab.title,
        content: tab.text,
        image: tab.image.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
      }
    }),
    button: {
      notLink: true,
      outline: false,
      phone: false,
      text: data.buttonText,
      fontSize: 'text-[1.125rem]',
      bgColor: 'transparent',
      borderColor: 'border-white',
      hoverBg: 'hover:bg-gray',
      hoverTextColor: 'hover:text-black-light2',
      fillColor: 'svgBlue',
      textColor: 'text-white',
      onClick: handleButton,
    },
    phone: {
      notLink: false,
      outline: false,
      phone: false,
      text: `${data.linkText} ${wp.acfOptionsCommonItems.commonItems.phoneNumber}`,
      fontSize: 'text-[1.125rem]',
      bgColor: 'bg-white',
      hoverBg: 'hover:bg-gray',
      hoverTextColor: 'hover:text-black-light2',
      fillColor: 'svgRed',
      textColor: 'text-black-light2',
      href: `tel:${wp.acfOptionsCommonItems.commonItems.phoneNumber}`,
    },
    textColor: 'text-white',
    borderColor: 'border-white',
    hoverBgColor: 'hover:lg:bg-gradient-to-r hover:lg:from-white/50',
    activeBgColor: 'lg:!bg-gradient-to-r lg:!from-white/50',
    foregroundImageDesktop: {
      src: data.desktopForegroundImage.localFile.childImageSharp.gatsbyImageData.images.fallback
        .src,
      srcSet:
        data.desktopForegroundImage.localFile.childImageSharp.gatsbyImageData.images.fallback
          .srcSet,
      sizes:
        data.desktopForegroundImage.localFile.childImageSharp.gatsbyImageData.images.fallback.sizes,
      width: data.desktopForegroundImage.localFile.childImageSharp.gatsbyImageData.width,
      height: data.desktopForegroundImage.localFile.childImageSharp.gatsbyImageData.height,
      alt: data.desktopForegroundImageAltText,
    },
  }
}
export function CaseStudiesFunction() {
  const data = useCaseStudiesQuery()
  return {
    title: data.title,
    cases: data.cases.map(case2 => {
      return {
        image: {
          src: case2.image.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
          srcSet: case2.image.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet,
          sizes: case2.image.localFile.childImageSharp.gatsbyImageData.images.fallback.sizes,
          width: case2.image.localFile.childImageSharp.gatsbyImageData.width,
          height: case2.image.localFile.childImageSharp.gatsbyImageData.height,
          alt: case2.altText,
        },
        title: case2.title,
        location: case2.location,
        text: case2.text,
      }
    }),
    caseTextColor: 'text-white',
    caseBgColor: 'bg-blue/90',
  }
}
export function CouponPageFunction(coupon) {
  const data = useCouponSectionQuery()
  return {
    logo: {
      src: data.couponLogo.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
      srcSet: data.couponLogo.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet,
      width: data.couponLogo.localFile.childImageSharp.gatsbyImageData.width,
      height: data.couponLogo.localFile.childImageSharp.gatsbyImageData.height,
      sizes: data.couponLogo.localFile.childImageSharp.gatsbyImageData.sizes,
    },
    logoAltText: data.couponLogoAltText,
    primary: true,
    topBgColor: 'bg-white',
    bgColor1: 'bg-red',
    bgColor2: 'bg-blue',
    innerBgColor1: 'bg-red-darker',
    innerBgColor2: 'bg-blue-light2',
    borderColor: 'border-white',
    textColor: '!text-white',
    title: coupon.text,
    description: data.couponDescriptionText,
    printText: data.printButtonText,
  }
}
export function WhatWeOfferFunction(handleButton, data) {
  const wp = data.wpPage.whatWeOffer.whatWeOffer
  const phone = useHeaderQuery()
  return {
    bgColor: 'bg-red lg:bg-transparent',
    bgImgMobile:
      wp.backgroundImageMobile.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
    bgImg: wp.backgroundImageDesktop.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
    tabBgMobile: wp.tabBackgroundMobile.localFile.publicURL,
    tabBgDesktop: wp.tabBackgroundDesktop.localFile.publicURL,
    textColor: 'text-white lg:text-blue',
    activeTextColor: 'text-blue lg:text-white',
    subitemTextColor: 'text-blue',
    title: wp.title,
    subtitle: wp.subtitle,
    tabs: wp.tabs.map(tab => {
      return {
        icon: tab.icon.localFile.publicURL,
        image: tab.image.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
        label: tab.label,
        title: tab.title,
        content: tab.text,
        linkText: tab.link.title,
        linkUrl: tab.link.url,
        subitems: tab.subitems.map(subitem => {
          return {
            label: subitem.label,
            content: subitem.content,
          }
        }),
      }
    }),
    subitemBgColor: 'bg-white lg:bg-tan',
    subitemButtonProps: {
      notLink: false,
      outline: true,
      phone: false,
      fontSize:
        'text-[1.125rem] md:text-[1.536rem] lg:text-[0.8rem] xxl:text-[1rem] xxxl:text-[1.33331rem] py-2 lg:py-0',
      bgColor: 'bg-white lg:bg-red',
      hoverBg: 'hover:bg-blue',
      hoverTextColor: 'hover:text-white',
      textColor: 'text-blue lg:text-white',
      borderColor:
        'border-white lg:border-red !translate-x-1 !translate-y-1 xxl:!translate-x-2 xxl:!translate-y-2',
    },
    requestButtonProps: {
      notLink: true,
      outline: true,
      phone: false,
      text: wp.quoteButtonText,
      fontSize:
        'text-[1.125rem] md:text-[1.536rem]  lg:text-[0.8rem] xxl:text-[1rem] xxxl:text-[1.33331rem] py-2 lg:py-0',
      bgColor: 'bg-blue',
      hoverBg: 'hover:bg-white',
      hoverTextColor: 'hover:text-blue',
      textColor: 'text-white',
      borderColor:
        'border-white lg:border-blue !translate-x-1 !translate-y-1 xxl:!translate-x-2 xxl:!translate-y-2',
      onClick: handleButton,
    },
    callOutText: wp.calloutText,
    callOutButtonProps: {
      notLink: false,
      outline: true,
      phone: true,
      text: `${phone.wp.acfOptionsCommonItems.commonItems.phoneNumber}`,
      fontSize:
        'text-[1.125rem] sm:text-[1.728rem] md:text-[2.304rem] lg:text-[1rem] xxl:text-[1.4375rem] ',
      fillColor: 'svgBlue',
      bgColor: 'bg-white',
      hoverBg: 'hover:bg-red',
      hoverTextColor: 'hover:text-white',
      textColor: 'text-blue',
      borderColor: 'border-transparent',
      href: `tel:${phone.wp.acfOptionsCommonItems.commonItems.phoneNumber}`,
    },
    borderColor: 'border-white lg:border-red',
    listBgColor:
      'bg-gradient-to-b from-[#F4F2F3]/[0%] to-[#B92D41] lg:from-[#F4F2F3]/[75%] lg:to-[#E4D4D5]/[75%]',
    hoverListBgColor:
      'hover:bg-gradient-to-b from-[#F4F2F3]/[0%] to-[#B92D41] lg:from-[#F4F2F3]/[75%] lg:to-[#E4D4D5]/[75%]',
    calloutBg: wp.callOutBackground.localFile.publicURL,
    calloutTextColor: 'text-white',
    fillColor: 'circleColor',
    activeFillColor: '[&_path]:fill-blue [&_path]:lg:fill-white',
    iconFillColor: '[&_path]:fill-white [&_path]:lg:fill-red',
  }
}
export function WhyUsFunction() {
  const data = useWhyHirschbergQuery()
  return {
    bgColor: 'bg-white',
    bgImg:
      data.backgroundImageDesktop.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
    bgImgMobile:
      data.backgroundImageMobile.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
    title: data.title,
    tabs: data.tabs.map(tab => {
      return {
        icon: tab.icon.localFile.publicURL,
        label: tab.label,
        labelMobile: tab.labelMobile,
        image1: tab.image1.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
        image2: tab.image2.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
        title: tab.title,
        content: tab.content,
        linkText: tab.link.title,
        linkUrl: tab.link.url,
        subitems: tab.subitems.map(subitem => {
          return {
            label: subitem.label,
            content: subitem.content,
          }
        }),
      }
    }),
    icon: data.listIcon.localFile.publicURL,
    buttonProps: {
      notLink: false,
      outline: true,
      phone: false,
      fontSize:
        'text-[1.125rem] md:text-[1.536rem] lg:text-[0.8rem] xxl:text-[1rem] xxxl:text-[1.33331rem] py-1 sm:py-2 lg:py-0 xxl:py-1',
      bgColor: 'bg-blue',
      hoverBg: 'hover:bg-red',
      hoverTextColor: 'hover:text-white',
      textColor: 'text-white',
      borderColor: 'border-white',
    },
    textColor: 'text-blue',
    activeTextColor: '!text-red',
    hoverTextColor: 'hover:text-red',
    borderColor: 'border-red',
    triangleColor: 'border-red',
    imageBorderColor: 'border-white',
    fillColor: '[&_path]:fill-black',
    activeFillColor: '[&_path]:fill-red',
    hoverFillColor: '[&_path]:hover:!fill-red',
  }
}
export function BackToTopFunction() {
  return {
    backgroundColor: 'bg-red',
  }
}
export function ServiceAreasFunction(handleButton) {
  const data = useServiceAreasQuery()
  return {
    bgColor: 'bg-white',
    bgImg:
      data.backgroundImageDesktop.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
    bgImgMobile:
      data.backgroundImageMobile.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
    containerBg:
      data.containerBackgroundDesktop.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
    containerBgMobile:
      data.containerBackgroundMobile.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
    title: data.title1,
    subtitle: data.title2,
    image: {
      src: data.image1.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
      srcSet: data.image1.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet,
      width: data.image1.localFile.childImageSharp.gatsbyImageData.width,
      height: data.image1.localFile.childImageSharp.gatsbyImageData.height,
      sizes: data.image1.localFile.childImageSharp.gatsbyImageData.sizes,
    },
    imageAltText: data.image1AltText,
    content: data.text,
    tabs: data.countiesAndTowns.map(county => {
      return {
        serviceAreasCountyName: county.county,
        serviceAreasTowns: county.towns,
      }
    }),
    lineBorderColor: 'border-orange-light',
    containerBgColor: 'bg-blue-dark',
    titleColor: 'text-blue',
    textColor: 'text-white',
    buttonProps: {
      notLink: true,
      rounded: true,
      iconType: 'service',
      iconBgColor: 'bg-blue',
      borderColor: 'border-white',
      iconFill: 'svgWhite',
      text: data.buttonText,
      bgColor: 'bg-red',
      hoverBgColor: 'hover:bg-blue',
      fontSize: 'text-base xxl:text-[1.33331rem]',
      textColor: 'text-white',
      onClick: handleButton,
    },
  }
}
export function RogueCouponFunction() {
  const data = useCouponSectionQuery()
  return {
    logo: {
      src: data.couponLogo.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
      srcSet: data.couponLogo.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet,
      width: data.couponLogo.localFile.childImageSharp.gatsbyImageData.width,
      height: data.couponLogo.localFile.childImageSharp.gatsbyImageData.height,
      sizes: data.couponLogo.localFile.childImageSharp.gatsbyImageData.sizes,
    },
    logoAltText: data.couponLogoAltText,
    primary: true,
    topBgColor: 'bg-white',
    bgColor1: 'bg-red',
    bgColor2: 'bg-blue',
    innerBgColor1: 'bg-red-darker',
    innerBgColor2: 'bg-blue-light2',
    borderColor: 'border-white',
    textColor: 'text-white',
    title: '$50 off your next service',
    finePrint:
      '*Must mention this special at the time of scheduling. Cannot be combined with any other offers, discounts, or promotions. Limit one per household.',
    description: 'Call Office for Details',
    printText: 'Print Me',
  }
}
